import Aform from '@/components/Aform';
import './index.css';

export default {
  name: 'BfSearch',
  render() {
    const { ...attrs } = this.$attrs;
    return (<Aform inline global={false} {...{ attrs }} />);
  }
}